import { render } from "./SimpleTextItem1.vue?vue&type=template&id=7249e170&scoped=true&ts=true"
import script from "./SimpleTextItem1.vue?vue&type=script&lang=ts"
export * from "./SimpleTextItem1.vue?vue&type=script&lang=ts"

import "./SimpleTextItem1.vue?vue&type=style&index=0&id=7249e170&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7249e170"]])

export default __exports__